import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./baseStyles.css";

export default function MyOrganizerSetupPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const quickCaptureUrl = location.state?.quickCaptureUrl;
  const needsTokenRotationForLink = location.state?.needsTokenRotationForLink;

  return (
    <div className="container" style={{ padding: "24px", maxWidth: "700px" }}>
      <h2>myOrganizer Setup</h2>

      {quickCaptureUrl ? (
        <>
          <p>Your Quick Add link is ready. Save this link to your phone home screen.</p>

          <textarea
            readOnly
            value={quickCaptureUrl}
            style={{ width: "100%", minHeight: "90px", marginTop: "12px" }}
          />

          <p style={{ marginTop: "12px" }}>
            On iPhone: open this link in Safari, tap Share, then Add to Home Screen.
          </p>
        </>
      ) : (
        <>
          <p>myOrganizer is already set up.</p>
          {needsTokenRotationForLink && (
            <p>
              The Quick Add link was already created earlier. To show a new link,
              we’ll add a Rotate Link button next.
            </p>
          )}
        </>
      )}

      <div style={{ marginTop: "24px" }}>
        <button
          className="save-button"
          onClick={() => navigate("/item-manager/Organizer")}
        >
          Go to Organizer
        </button>
      </div>
    </div>
  );
}